/** 브라우저 로그인 마커 — `be.ts`·`wsSingleton`이 공유 (순환 참조 방지) */

export const TOKEN_KEY = "seotda_token";
export const USER_ID_KEY = "seotda_user_id";
export const USERNAME_KEY = "seotda_username";

export function getStoredToken(): string | null {
  if (typeof window === "undefined") return null;
  return localStorage.getItem(TOKEN_KEY);
}

export function getStoredUserId(): string | null {
  if (typeof window === "undefined") return null;
  return localStorage.getItem(USER_ID_KEY);
}

export function getStoredUsername(): string | null {
  if (typeof window === "undefined") return null;
  return localStorage.getItem(USERNAME_KEY);
}

/** 토큰·쿠키만 제거 (WebSocket은 호출부에서 끊음) */
export function clearLocalAuthSession(): void {
  if (typeof window === "undefined") return;
  localStorage.removeItem(TOKEN_KEY);
  localStorage.removeItem(USER_ID_KEY);
  localStorage.removeItem(USERNAME_KEY);
  document.cookie = "isLoggedIn=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/";
}
